// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '@/styles/reset.css';
import '@/styles/common.css';
import './assets/icon/iconfont.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Router from 'vue-router'
import _axios from '@/ws/domain.js';
import bus from '@/common/common-methods/eventBus.js';
import {store} from '@/vuex/store.js';
import commonMethods from '@/common/common-methods/commonMethods.js';
import urls from '@/ws/api.js';
// pc端头部、脚部
import HeaderComponentP from '@/components/pc/common/header/HeaderComponent';
import FooterComponentP from '@/components/pc/common/footer/FooterComponent';
// pc端默认文章列表
import DefaultArticleListP from '@/components/pc/common/default-article-list/DefaultArticleList.vue';
// pc端右侧各文章模块
import RightModulesP from '@/components/pc/common/right-modules/RightModules.vue';
// pc端用户左侧菜单组件
import UserLeftMenuP from '@/components/pc/common/user-left-menu/UserLeftMenu.vue';
// 移动端头部
import HeaderComponentM from '@/components/mobile/common/header/HeaderComponent';
// 移动端登录组件
import LoginM from '@/components/mobile/common/login/Login.vue';
import Viewer from 'v-viewer'//图片预览
import 'viewerjs/dist/viewer.css'
Vue.prototype.Viewer = Viewer;
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 
    zIndex: 9999,
    inline: true, //启用lnline模式
    button: true, //显示右上角关闭按钮
    navbar: false, //显示缩略图导航
    title: false, //显示当前图片的标题
    toolbar: false, //显示工具栏
    tooltip: true, //显示缩放百分比
    movable: true, //显示可移动
    zoomable: true, //图片是否可缩放
    rotatable: false, //图片是否可旋转
    scalable: false, //图片是否可翻转
    transition: true, //使用css3过度
    fullscreen: true, //播放时是否全屏
    keyboard: true, //是否支持键盘
    url: 'data-source' //设置大图片的url
  }
})

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$axios = _axios;
Vue.prototype.Urls = urls;
Vue.prototype.Bus = bus;
Vue.prototype.cm = commonMethods;

Vue.component('HeaderComponentP', HeaderComponentP);
Vue.component('FooterComponentP', FooterComponentP);
Vue.component('DefaultArticleListP', DefaultArticleListP);
Vue.component('RightModulesP', RightModulesP);
Vue.component('UserLeftMenuP', UserLeftMenuP);
Vue.component('HeaderComponentM', HeaderComponentM);
Vue.component('LoginM', LoginM);

router.afterEach((to, from, next) => {
  let pageList = ['ArticleDetailP', 'ArticleDetailM'];
  if(pageList.indexOf(from.name) >= 0 && pageList.indexOf(to.name) < 0) {
    // 从文章详情页出来
    let top = window.sessionStorage.getItem('pageScrollTop');
    setTimeout(() => {
      top && window.scrollTo(0, Number(top));
    }, 10);
  } else {
    if(pageList.indexOf(to.name) >= 0) {
      // 去文章详情页
      window.sessionStorage.setItem('pageScrollTop', document.documentElement.scrollTop);
    }
    window.scrollTo(0, 0);
  }
  // 不完全可行
});

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { 
    App,
    HeaderComponentP,
    FooterComponentP,
    DefaultArticleListP,
    RightModulesP,
    UserLeftMenuP,
    HeaderComponentM,
    LoginM,
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js